import { BaseEntityFieldsArray } from '@40seas/models';
import { Omit } from '@40seas/entities/common';
import { CreditSafePortfolioEvent } from './credit-safe-portfolio.event.entity';

export class CreateCreditSafePortfolioEventDto extends Omit(CreditSafePortfolioEvent, [...BaseEntityFieldsArray]) {}
